import React from 'react';

const TermsAndConditions = () => {
  return (
    <section className="py-4" style={{ background: '#FAF6ED' }}>
      <div className="container">
        <div className="card border-0 shadow-sm rounded-4 p-4" style={{ background: '#fff' }}>
          <h1
            className="fw-bold mb-3"
            style={{
              fontFamily: "'Playfair Display', serif",
              color: '#2c2c2c',
              fontSize: '1.5rem',
            }}
          >
            Terms &amp; Conditions
          </h1>

          <p style={{ fontSize: '.96rem', color: '#4a3e19' }}>
            These Terms &amp; Conditions govern all purchases, bookings, and use of services from Zoteya Beauty Salon (“Zoteya Beauty”, “we”, “us”, or “our”).
            By placing an order or using our services, you agree to these terms.
          </p>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            1. Orders &amp; Payment
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>All products are primarily offered on a pre‑order and custom basis.</li>
            <li>Full payment is required to confirm your order or booking.</li>
            <li>Payments are processed securely via our third‑party payment provider; we do not store card details.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            2. Lead Times &amp; Fulfilment
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>Estimated production lead times apply as stated on our product and Shipping Policy pages.</li>
            <li>Occasionally, limited ready stock may be available, but this is not guaranteed.</li>
            <li>By ordering, you acknowledge and accept the stated lead times for procurement and preparation.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            3. Shipping, Returns &amp; Refunds
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Our detailed Shipping and Returns terms form part of these Terms &amp; Conditions. 
            Please review the separate Shipping &amp; Returns Policy page before checkout.
          </p>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            4. Client Responsibilities
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>Provide accurate personal and delivery information at checkout.</li>
            <li>Review product descriptions, lead times, and policies before placing an order.</li>
            <li>Use products according to any care instructions supplied.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            5. Custom Work &amp; Expectations
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>For custom wigs and colour work, one clear reference image or brief is strongly recommended.</li>
            <li>Submitting multiple or conflicting references may lead to misinterpretation and delays.</li>
            <li>We recommend a consultation if you are unsure about your desired look before placing an order.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            6. Privacy
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Your personal information is handled in line with our Privacy Policy. 
            By using our website or services, you consent to the collection and use of your data as described there.
          </p>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            7. Policy Updates
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Zoteya Beauty may update these Terms &amp; Conditions and related policies from time to time. 
            The version in force at the time of your order will apply to that purchase.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;

